<template>
  <div>
    <span class="pretext">{{text}}</span>
    <b-form-input type="text" size="sm" class="input-1-3" maxlength="2" required v-model="time.h" trim @input="verifyInput('h')" @blur="verifyNotEmpty('h')" />
    <span>:</span>
    <b-form-input type="text" size="sm" class="input-1-3" maxlength="2" required v-model="time.m" trim @input="verifyInput('m')" @blur="verifyNotEmpty('m')" />
    <span>:</span>
    <b-form-input type="text" size="sm" class="input-1-3" maxlength="2" required v-model="time.s" trim @input="verifyInput('s')" @blur="verifyNotEmpty('s')" />
  </div>
</template>

<script>

const minValue = 0;
const maxHours = 23;
const maxMinSec = 59;

export default {
  props: {
    time: {
      type: [Object],
      required: true,
    },
    text: {
      type: [String],
      required: false,
      default: 'Time:',
    },
    type: {
      type: [String],
      required: false,
      default: 'from',
    },
  },
  methods: {
    verifyInput(type) {
      const parsedValue = Number(this.time[type]);
      if (Number.isNaN(parsedValue) || !Number.isInteger(parsedValue) || this.time[type].trim().length > 2 || parsedValue === 0) {
        this.time[type] = '00';
        return;
      }
      switch (type) {
        case 'h':
          if (parsedValue > maxHours) this.time[type] = String(maxHours);
          break;
        case 'm':
        case 's':
          if (parsedValue > maxMinSec) this.time[type] = String(maxMinSec);
          break;
        default:
      }
    },
    verifyNotEmpty(type) {
      const parsedValue = Number(this.time[type]);
      if (Number.isNaN(parsedValue) || !Number.isInteger(parsedValue) || this.time[type].trim().length === 0) {
        this.time[type] = '00';
      }
      if (parsedValue < minValue) this.time[type] = '00';
      if (parsedValue < 10) this.time[type] = `0${parsedValue}`;

      if (this.type === 'to') {
        this.verifyMaxTime();
      }
    },
    verifyMaxTime() {
      if (this.time.h === '00' && this.time.m === '00' && this.time.s === '00') {
        this.time.h = String(maxHours);
        this.time.m = String(maxMinSec);
        this.time.s = String(maxMinSec);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pretext{
  display: inline-block;
  width: 50px;
}
.input-1-3{
  display: inline-block;
  width: 36px;
}
</style>
